var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPushPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667,
    d: "m6.98 13.014-4.713 4.714M9.745 5.535l-1.3 1.3c-.106.107-.16.16-.22.202a.833.833 0 0 1-.172.092 1.727 1.727 0 0 1-.29.071l-3.053.611c-.794.159-1.19.238-1.376.447a.833.833 0 0 0-.203.668c.039.277.325.563.897 1.135l5.905 5.905c.572.572.858.858 1.136.897a.833.833 0 0 0 .667-.202c.21-.186.289-.583.447-1.376l.611-3.054c.03-.147.044-.22.071-.29a.833.833 0 0 1 .092-.172c.042-.06.096-.113.202-.22l1.3-1.3c.068-.068.102-.102.14-.132a.836.836 0 0 1 .104-.07 1.73 1.73 0 0 1 .174-.08l2.079-.892c.606-.26.91-.39 1.047-.6a.834.834 0 0 0 .12-.622c-.05-.246-.283-.48-.75-.946l-4.286-4.286c-.466-.466-.7-.7-.946-.75a.833.833 0 0 0-.622.12c-.21.138-.34.441-.6 1.048l-.89 2.078c-.039.088-.058.133-.081.174a.833.833 0 0 1-.071.105c-.03.037-.064.071-.132.139Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushPin);
export default __webpack_public_path__ + "static/media/push-pin.eda84e91f503a13d2b3c60a76bd9d942.svg";
export { ForwardRef as ReactComponent };